import React, { useEffect, useRef } from 'react';
import logo from '../../assets/images/logoRebid.png';
import AuthService from '../../services/authService';

function LogoutUser() {
  const ref = useRef();

  useEffect(() => {
    const logoutClick = ref.current;
    setTimeout(() => {
      AuthService.logout();
    }, 0);
    // setTimeout(() => {
    //   logoutClick.click();
    // }, 100);
  }, []);

  return (
    <div className="keycloak">
      <div className="keycloak_logout">
        <div className="keycloak_image">
          <img src={logo} />
        </div>
        <div className="keycloak_actions">
          <p>
            Go back to{' '}
            <span
              className="keycloak_actions_link"
              onClick={() => (window.location.href = `${window.location.origin}/signup`)}
            >
              Signup
            </span>
          </p>
          <p>
            or{' '}
            <span
              ref={ref}
              id="login_btn"
              className="keycloak_actions_link"
              onClick={() => AuthService.login()}
            >
              Login?
            </span>
          </p>
        </div>
      </div>
    </div>
  );
}

export default LogoutUser;
